import taxonomyData from '../data/taxonomy.json';

class TaxonomyService {
  constructor() {
    this.taxonomy = taxonomyData;
  }

  // Get artifacts by category
  getArtifactsByCategory(category) {
    return this.taxonomy.filter(item => item.category === category);
  }

  // Get core recommended artifacts
  getCoreArtifacts() {
    return this.taxonomy.filter(item => item.core_recommended === 'true');
  }

  // Get artifacts by lifecycle stage
  getArtifactsByStage(stage) {
    return this.taxonomy.filter(item => 
      item.lifecycle_stage.includes(stage)
    );
  }

  // Get diagram-type artifacts
  getDiagramArtifacts() {
    return this.taxonomy.filter(item => 
      item.diagram_or_text === 'diagram' || item.diagram_or_text === 'mixed'
    );
  }

  // Get artifact by acronym
  getArtifact(acronym) {
    return this.taxonomy.find(item => item.acronym === acronym);
  }

  // Get suggested artifacts based on requirements
  getSuggestedArtifacts(requirements) {
    const suggested = [];
    
    // Always include core artifacts
    suggested.push(...this.getCoreArtifacts());
    
    // Add specific artifacts based on requirements
    if (requirements.hasCompliance) {
      suggested.push(...this.getArtifactsByCategory('Security, Privacy & Compliance'));
    }
    
    if (requirements.hasDataProcessing) {
      suggested.push(...this.getArtifactsByCategory('Data Architecture & Governance'));
    }
    
    if (requirements.hasIntegrations) {
      suggested.push(...this.getArtifactsByCategory('Integration & API'));
    }
    
    // Remove duplicates
    return suggested.filter((item, index, self) => 
      index === self.findIndex(t => t.acronym === item.acronym)
    );
  }

  // Get all categories
  getCategories() {
    return [...new Set(this.taxonomy.map(item => item.category))];
  }
}

const taxonomyService = new TaxonomyService();
export default taxonomyService;